<template>
    <!-- PC -->
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div><img src="/static\images\vi\newManual\forgotPassManual-1.png" alt="" /></div>
                <div>
                    <p>① Nếu bạn quên mật khẩu thì nhấn vào dòng chữ [Nếu bạn quên mật khẩu, Vui lòng nhấp vào đây] ở màn hình đăng nhập.</p>
                </div>
                <div><img src="/static\images\vi\newManual\forgotPassManual-2.png" alt="" /></div>
                <div>
                    <p>② Nhập địa chỉ email mà bạn dùng để đăng ký tài khoản ở màn hình [Đặt lại mẩu khẩu] như bên dưới</p>
                    <p>③ Nhấn nút [Gửi]</p>
                </div>
                <div><img src="/static\images\vi\newManual\forgotPassManual-3.png" alt="" /></div>
                <div>
                    <p>④ Sau khi gửi thông tin email thành công, màn hình [Hoàn thành gửi E-mail cài đặt lại mật khẩu như bên dưới xuất hiện.</p>
                    <p>&nbsp;Hãy truy cập vào email của bạn, mở email được gửi đến từ Study-arts.</p>
                </div>
                <div><img src="/static\images\vi\newManual\forgotPassManual-4.png" alt="" /></div>
                <div>
                    <p>⑤ Mở email ra, truy cập vào đường link [URL thiết lập lại mật khẩu] được ghi trong email để cài đặt lại mật khẩu mới</p>
                    <p>※ Lưu ý: đường link cài đặt lại mật khẩu chỉ có hiệu lực trong 10p kể từ khi email được gửi đến.</p>
                    <p>&nbsp;Nếu sau 10p mà bạn chưa vào link, thì thực hiện lại từ bước ①</p>
                </div>
                <div><img src="/static\images\vi\newManual\forgotPassManual-5.png" alt="" /></div>
                <div>
                    <p>⑥ Sau khi truy cập vào URL trong email, thì màn hình bên dưới sẽ được hiển thị</p>
                    <p>&nbsp;Nhập mật khẩu mới vào rồi nhấn nút [Xác nhận].</p>
                    <p>※ Lưu ý: mật khẩu phải có từ 8-16 ký tự, gồm cả chữ in hoa, in thường và số.</p>
                </div>
                <div><img src="/static\images\vi\newManual\forgotPassManual-6.png" alt="" /></div>
                <div>
                    <p>⑦ Sau khi cài đặt lại mật khẩu mới thành công thì màn hình bên dưới xuất hiện.</p>
                    <p>&nbsp;Nhấn nút [Quay lại trang đầu] để quay về trang chủ, rồi đăng nhập bằng mật khẩu mới.</p>
                </div>
            </div>
        </div>
    </div>
    <!-- Mobile -->
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <h1>Mobile</h1>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {},
        watch: {},
        methods: {
            scrollToElement(id) {
                let element = document.getElementById(id);
                element.scrollIntoView();
            },
        },
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    .lkt-manual ul {
        margin-left: 20px;
        list-style: square;
        font-size: 12pt;
    }
    ul li {
        cursor: pointer;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/en/forgotPass_manual.vue